module.exports = __webpack_public_path__ + "img/entry-preview.1dd9a1ed.png";